import React from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';

export interface FilterBarOption {
    value: string;
    label: string;
}

export interface FilterBarFilter {
    key: string;
    label: string;
    value: string;
    options: FilterBarOption[];
    onChange: (value: string) => void;
}

interface FilterBarProps {
    filters: FilterBarFilter[];
    /** Aparece solo si hay algún filtro puesto. */
    onClear?: () => void;
    /** El valor que significa "sin filtro". Por defecto `'all'`. */
    emptyValue?: string;
    /** Lo que va a la derecha (un botón de acción). */
    children?: React.ReactNode;
}

/**
 * Renglón de filtros con "Limpiar" (plan de UI §2.3, se estrena en la pestaña
 * Gastos). Regla de los 6: hasta seis filtros van en un renglón propio arriba de la
 * tabla; más de seis, a un cajón. Cada filtro es un Select con "Todos" como
 * primera opción; lo que filtra lo decide la pantalla (en cliente, sin índices).
 */
const FilterBar: React.FunctionComponent<FilterBarProps> = ({ filters, onClear, emptyValue = 'all', children }) => {
    const hasActive = filters.some((filter) => filter.value !== emptyValue);
    return (
        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
            {filters.map((filter) => (
                <FormControl key={filter.key} size="small" sx={{ minWidth: 160, maxWidth: 240 }}>
                    <InputLabel id={`filter-${filter.key}`}>{filter.label}</InputLabel>
                    <Select
                        labelId={`filter-${filter.key}`}
                        label={filter.label}
                        value={filter.value}
                        onChange={(event) => filter.onChange(String(event.target.value))}
                    >
                        <MenuItem value={emptyValue}>Todos</MenuItem>
                        {filter.options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ))}
            {onClear && hasActive && (
                <Button size="small" onClick={onClear}>
                    Limpiar
                </Button>
            )}
            {children && (
                <Stack direction="row" spacing={1} ml="auto !important">
                    {children}
                </Stack>
            )}
        </Stack>
    );
};

export default FilterBar;
